var map = {
	"./anchor-blue.svg": 1767,
	"./arr-down.svg": 1768,
	"./arr-up.svg": 1769,
	"./arrow-down-blue.svg": 1770,
	"./arrow-down-circle.svg": 1771,
	"./arrow-down.svg": 1772,
	"./arrow-left.svg": 1773,
	"./arrow-right.svg": 1774,
	"./arrow-up-circle.svg": 1775,
	"./arrow-up.svg": 1776,
	"./article.svg": 1777,
	"./basket-light.svg": 1778,
	"./basket.svg": 1779,
	"./btn-arrow-dark.svg": 1780,
	"./btn-arrow-down-blue.svg": 1781,
	"./btn-arrow-down.svg": 1782,
	"./btn-arrow.svg": 1783,
	"./btn-info.svg": 1784,
	"./btn-play.svg": 1785,
	"./calendar.svg": 1786,
	"./chevron-down.svg": 1787,
	"./chevron-left.svg": 1788,
	"./chevron-right.svg": 1789,
	"./chevron-up.svg": 1790,
	"./clock.svg": 1791,
	"./cross.svg": 1792,
	"./curve-shape-narrow-swoosh.svg": 1793,
	"./curve-shape-right.svg": 1794,
	"./curve-shape-short.svg": 1795,
	"./curve-shape.svg": 1796,
	"./facebook.svg": 1797,
	"./gallery.svg": 1798,
	"./i.svg": 1799,
	"./instagram.svg": 1800,
	"./linkedin.svg": 1801,
	"./live-header-logo.svg": 1802,
	"./logo-aig-wo-short.svg": 1803,
	"./logo-aig-wo-venue.svg": 1804,
	"./logo-aig-wo.svg": 1805,
	"./logo-open.svg": 1806,
	"./menu-close.svg": 1807,
	"./menu-light.svg": 1808,
	"./minus.svg": 1809,
	"./mute.svg": 1810,
	"./pause.svg": 1811,
	"./play.svg": 1812,
	"./plus.svg": 1813,
	"./profile-light.svg": 1814,
	"./radioff.svg": 1815,
	"./radion.svg": 1816,
	"./read.svg": 1817,
	"./restart.svg": 1818,
	"./scores.svg": 1819,
	"./search.svg": 1820,
	"./sorting.svg": 1821,
	"./star.svg": 1822,
	"./symbol.svg": 1823,
	"./text.svg": 1824,
	"./tick.svg": 1825,
	"./ticket.svg": 1826,
	"./tiktok.svg": 1827,
	"./track.svg": 1828,
	"./triangle.svg": 1829,
	"./twitter.svg": 1830,
	"./unmute.svg": 1831,
	"./video.svg": 1832,
	"./watch.svg": 1833,
	"./youtube.svg": 1834
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 873;